'use client';

import { useMemo, useState } from 'react';
import classNames from 'classnames';
import { Button } from '@/features/button';
import SafeHtml from '@/components/safe-html';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
interface Props {
  content: string;
  className?: string;
}
export default function ExpandableText({
  content,
  className
}: Props) {
  const [isShowFullContent, setIsShowFullContent] = useState(false);
  const isTextOverflow = useMemo(() => content.length >= 400, [content]);
  const isCollapsed = !isShowFullContent && isTextOverflow;
  function handleClick() {
    setIsShowFullContent(!isShowFullContent);
  }
  return <div className='homepage-container' data-sentry-component="ExpandableText" data-sentry-source-file="expandable-text.tsx">
            <div className='relative h-auto w-full overflow-hidden whitespace-normal'>
                <div className={classNames(className, {
        'line-clamp-4 max-h-20 overflow-hidden text-ellipsis lg:max-h-26': isCollapsed
      })}>
                    <SafeHtml content={content} data-sentry-element="SafeHtml" data-sentry-source-file="expandable-text.tsx" />
                </div>
                {isCollapsed && <div className='absolute right-0 top-0 h-full w-full bg-gradient-to-t from-blackFriday' />}
            </div>
            <Button size='medium' graphicStyle='text' className={!isTextOverflow ? 'hidden' : 'mr-auto'} icon={{
      element: <IconArrowSquareLeft className='h-6 w-6' />,
      position: 'left'
    }} onClick={() => handleClick()} data-sentry-element="Button" data-sentry-source-file="expandable-text.tsx">
                {isShowFullContent ? 'بستن' : 'مشاهده بیشتر'}
            </Button>
        </div>;
}